<app-nav></app-nav>
<div [ngSwitch]="routeVal">
    <div *ngSwitchDefault>
        <app-employer-verification-list></app-employer-verification-list>
    </div>
    <div *ngSwitchCase="'1'">
        <app-employer-verification-list-dispute></app-employer-verification-list-dispute>
    </div>
    <div *ngSwitchCase="'2'">
        <app-employer-verify-document></app-employer-verify-document>
    </div>
    <div *ngSwitchCase="'3'">
        <app-employer-verify-document-edit></app-employer-verify-document-edit>
    </div>
</div>
<app-footer></app-footer>